// @ts-nocheck
/* eslint-disable */
export const googleStoreIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#fff" d="M2.667 1.156c.117 0 .233.031.334.09l10.67 6.177a.667.667 0 0 1 0 1.154L3 14.754a.667.667 0 0 1-1-.577V1.823c0-.368.298-.667.666-.667m5.528 7.786-2.999 3 3.8-2.2zM3.333 4.08v7.839l3.92-3.92zm6.856 2.868L9.138 7.999l1.052 1.052L12.006 8zM5.196 4.057l3 3 .8-.8z"/></svg>`,
    name: 'google-store' as const
};